export default __webpack_public_path__ + "static/media/triangle_need_help.ad6838d2.svg";